<template>
  <div class="settlement-tab-content">
    <div class="search-form-area">
      <el-form label-width="110px" style="padding: 20px 5px 0px" ref="form" :model="form">
        <el-row>
          <el-col :md="12" :lg="6">
            <el-form-item label="结算申请编号:" prop="dealCode"><el-input style="width: 100%" v-model="form.dealCode"
                placeholder="结算申请编号" clearable></el-input></el-form-item>
          </el-col>

          <el-col :md="12" :lg="12">
            <el-form-item label="结算金额:">
              <el-input v-model="form.money1" placeholder="结算金额" style="width: 48%"></el-input>
              <span style="width: 4%; text-align: center; display: inline-block">~</span>
              <el-input v-model="form.money2" placeholder="结算金额" style="width: 48%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="6">
            <el-form-item label="发布方:" prop="dealBody"><el-input style="width: 100%" v-model="form.dealBody"
                placeholder="请输入发布方名称" clearable></el-input></el-form-item>
          </el-col>
          <el-col :md="12" :lg="6" v-if="this.$store.state.user.isSourceOfTax != 1">
            <el-form-item label="税源地:" prop="bodyId">
              <el-select v-model="form.bodyId" placeholder="请选择" style="width:100%" clearable filterable>
                <el-option v-for="item in bodyPageList" :key="item.id" :label="`${item.bodyName}-${item.abbreviation}`"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :md="12" :lg="12">
            <el-form-item label="申请时间:">
              <el-date-picker :picker-options="pickerStartOptions(form.endDate)" style="width: 48%"
                v-model="form.startDate" placeholder="开始时间" type="date" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"></el-date-picker>
              <span style="width: 4%; text-align: center; display: inline-block">~</span>
              <el-date-picker :picker-options="pickerEndOptions(form.startDate)" style="width: 48%"
                v-model="form.endDate" placeholder="结束时间" type="date" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="6">
            <el-form-item label="任务大类:">
              <el-select style="width: 100%" v-model="form.taskType" placeholder="请选择任务大类" clearable filterable>
                <el-option v-for="item in taskList" :key="item.ticketProId" :value="item.ticketProject"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="24">
            <el-form-item label-width="0px">
              <div style="text-align: right">
                <el-button type="primary" @click="handleQuery()">查询</el-button>
                <el-button type="info" @click="handleReset()">重置</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-table ref="refTable" :height="tableHeight" style="border-top: 2px solid #ccc" :data="tableData" :show-summary="true" :summary-method="getSummaries"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" header-align="center" align="center" width="50" class-name="selection">
      </el-table-column>
      <el-table-column type="index" label="序号" width="50" header-align="center" align="center"x>
      </el-table-column>
      <el-table-column prop="dealCode" label="结算申请编号" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="taskCode" label="任务发布编号" header-align="center" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" class="el_hover_dectrion" @click="goTaskInfo(scope.row.taskId)">{{
            scope.row.taskCode }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="contractCode" label="合同编号" header-align="center" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" class="el_hover_dectrion" @click="infoHandle(scope.row)">{{
            scope.row.contractCode }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="taskTypeName" label="任务大类" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="publishName" label="发布方" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="abbreviation" label="税源地简称" header-align="center" align="center"></el-table-column>

      <el-table-column prop="payee" label="收款方信息" header-align="center" align="center">
        <template slot-scope="scope">
          <el-button style="word-break: break-all; white-space: wrap" type="text" size="small"
            @click="handleSee(scope.row)">查看</el-button>
          <!-- <span style="color:#3A7DD1;cursor: pointer;" class="el_hover_dectrion"  @click="handleSee(scope.row)" >查看</span> -->
        </template>
      </el-table-column>
      <el-table-column prop="money" label="结算总额" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="amountPayable" label="企业应付金额" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="serviceCharge" label="综合服务费" header-align="center" align="center"></el-table-column>
      <el-table-column prop="preTaxAmount" label="税前金额" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="personalTaxAmount" label="个税" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="vatTaxAmount" label="增值税" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="additionalTaxAmount" label="增值附加税" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="individualAmount" label="个人实际收款金额" header-align="center" align="center">
        </el-table-column>
      <el-table-column prop="earnestAmount" label="保证金" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="sourceOrg" label="来源企业" header-align="center" align="center" show-overflow-tooltip>
			<template slot-scope="scope">
				<span>{{ scope.row.sourceOrg == 'HY' ? '海茵科技' : '' }}</span>
			</template>
			</el-table-column>
      <el-table-column prop="status" label="交易状态" header-align="center" align="center" width="130px">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0" size="small" type="danger">草稿</el-tag>
          <el-tag v-if="scope.row.status == 1" size="small" type="warning">待审核</el-tag>
          <el-tag v-if="scope.row.status == 2" size="small">待支付</el-tag>
          <el-tag v-if="scope.row.status == 3" size="small" type="success">已支付</el-tag>
          <el-tag v-if="scope.row.status == 4" size="small" type="success">部分到账</el-tag>
          <el-tag v-if="scope.row.status == 6" size="small" type="warning">全部到账</el-tag>
          <el-tag v-if="scope.row.status == 7" size="small" type="danger">交易失败待支付</el-tag>
          <el-tag v-if="scope.row.status == 8" size="small" type="danger">已驳回</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="reviewer" label="审核人" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="updateDate" label="申请时间" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="operation" label="操作" header-align="center" align="center" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="
            scope.row.status == 1 &&
            $hasPermission('plat:batch-settlement-list:verify')
          " style="word-break: break-all; white-space: wrap" type="text" size="small"
            @click="openAuditDia(scope.row)">审核</el-button>
          <el-button v-else-if="
            scope.row.status == 2 &&
            $hasPermission('plat:batch-settlement-list:pay')
          " style="word-break: break-all; white-space: wrap" type="text" class="el-button--primary" size="small"
            @click="handlePayment(scope.row)">支付</el-button>
          <span v-else>— —</span>
          <el-button v-if="scope.row.status == 1" style="
              word-break: break-all;
              white-space: wrap;
              display: block;
              margin: 0 auto;
              padding: 5px 0;
            " type="text" size="small" @click="handleYsd(scope.row)">查看服务成果验收单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="pageObject.page" :page-sizes="[10, 20, 50, 100]"
      :page-size="pageObject.limit" :total="pageObject.total" layout="total, sizes, prev, pager, next, jumper"
      @size-change="handlePageSize" @current-change="handleCurrentPage">
    </el-pagination>
    <!--审核    以下   -->
    <dialog-to-examine v-if="dialogToExamineVisible" :DailogVisible="dialogToExamineVisible" :AuditInfo="auditInfo"
      @handleCloseA="handleCloseA" @handleAudit="handleAudit"></dialog-to-examine>
    <!--支付     以下   -->
    <dialog-to-be-paid v-if="dialogToBePaidVisible" :DailogVisible="dialogToBePaidVisible" :PaymentInfo="paymentInfo"
      @handleClose="handleClose" @PaymentSubmit="paymentSubmit"></dialog-to-be-paid>
    <dialog-pay ref="dialogpay" v-if="paymentInfo.length > 0" @CancelPay="CancelPay" :PaymentInfo="paymentInfo"
      @modifyPayPassword="modifyPayPassword" @paySuccess="paySuccess"></dialog-pay>
    <set-pwd ref="SetPwd"></set-pwd>
    <el-dialog title="查看服务成果验收单" v-if="yszVisable" :visible.sync="yszVisable" :before-close="yszVisableClose">
      <div class="el-upload-list-wrap-my">
        <el-upload action="" accept="image/*,application/pdf,application/zip" list-type="picture-card"
          :file-list="fileList" :http-request="fileUploadVoucher" class="imgHide">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img v-if="showPdf(file.url)" class="el-upload-list__item-thumbnail" src="../../../../../assets/img/pdf.png"
              alt="" />
            <img v-else-if="showZip(file.url)" class="el-upload-list__item-thumbnail"
              src="../../../../../assets/img/zip.jpg" alt="" />
            <img v-else class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            <span class="el-upload-list__item-actions">
              <span v-if="showPdf(file.url)" class="el-upload-list__item-preview" @click="pdfPreview(file.url)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span v-else-if="showZip(file.url)" class="el-upload-list__item-preview" @click="zipPreview(file.url)">
                <i class="el-icon-download"></i>
              </span>
              <span v-else class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
            </span>
          </div>
          <!-- <span v-show="!this.isViewStatus" slot="tip" class="uploadimgage"
            >上传仅支持图片、PDF、zip文件</span
          > -->
        </el-upload>

        <el-dialog :visible.sync="previewPicDialog" append-to-body>
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div>

      <span slot="footer" v-show="!this.isViewStatus" class="dialog-footer">
        <!-- <el-button type="primary" @click="fileBindTask">确 定</el-button> -->
        <!-- <el-button @click="uploadClose">取 消</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dialogToBePaid from "../dialog/dialog-to-be-paid.vue";
import DialogPay from "../dialog/dialog-payment.vue";
import SetPwd from "../../plattransactiondetais-set-pwd";
import { addDynamicRoute } from "@/router";
import dialogToExamine from "../dialog/dialog-to-examine.vue";
import ArrayUtils from "../../../../../utils/ArrayUtils";
export default {
  data() {
    return {
      tableHeight: 400,
      pickerStartOptions(endTime) {
        return {
          disabledDate(time) {
            if (endTime) {
              // 拼接 00:00:00 是为了统一日期从0点开始
              return time.getTime() > new Date(endTime + " 00:00:00").getTime();
            }
          },
        };
      },
      pickerEndOptions(startTime) {
        return {
          disabledDate(time) {
            if (startTime) {
              // 拼接 00:00:00 是为了统一日期从0点开始
              return (
                time.getTime() < new Date(startTime + " 00:00:00").getTime()
              );
            }
          },
        };
      },
      bodyPageList: [],
      fileList: [],
      yszVisable: false,
      yszImg: "",
      taskList: [],
      dialogImageUrl: "",
      isViewStatus: false,
      previewPicDialog: false,
      form: {
        taskType: "",
        money1: "",
        money2: "",
        dealCode: "",
        dealBody: "",
        status: "",
        startDate: "",
        endDate: "",
        bodyId: ''
      },
      dataList: [],
      //                分页器参数
      pageObject: {
        page: 1,
        limit: 10,
        total: 0,
      },
      //                支付明细弹框状态
      dialogToBePaidVisible: false,
      //                支付弹框
      payVisible: false,
      paymentInfo: [],
      multipleSelection: [],
      dialogToExamineVisible: false,
      auditInfo: "",
      countNum: {}
    };
  },
  components: {
    dialogToBePaid,
    DialogPay,
    SetPwd,
    dialogToExamine,
  },
  watch: {},

  computed: {
    tableData() {
      return this.dataList.map((item) => {
        return {
          ...item,
          taskType: ArrayUtils.getItemBy(
            this.taskList,
            "ticketProject",
            item.taskType
          ).ticketProject,
          money: item.money ? item.money.toFixed(2) : "",
          amountPayable: item.amountPayable
            ? item.amountPayable.toFixed(2)
            : "",
          serviceCharge: item.serviceCharge
            ? item.serviceCharge.toFixed(2)
            : "",
          preTaxAmount: item.preTaxAmount ? item.preTaxAmount.toFixed(2) : '',
          personalTaxAmount: item.personalTaxAmount ? item.personalTaxAmount.toFixed(2) : '',
          vatTaxAmount: item.vatTaxAmount ? item.vatTaxAmount.toFixed(2) : '',
          additionalTaxAmount: item.additionalTaxAmount ? item.additionalTaxAmount.toFixed(2) : '',
          individualAmount: item.individualAmount ? item.individualAmount.toFixed(2) : '',
          earnestAmount: item.earnestAmount ? item.earnestAmount.toFixed(2) : '',
        };
      });
    },
  },
  methods: {
    fileUploadVoucher(file) {
      let form = new FormData();
      form.append("file", file.file);
      this.$http
        .post("/oss/file/upload2", form)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.fileList.push({ name: "", url: res.data.url });
        })
        .catch((err) => { });
    },
    showPdf(url) {
      if (url.split(".")[url.split(".").length - 1].indexOf("pdf") > -1) {
        return true;
      } else {
        return false;
      }
    },
    showZip(url) {
      if (
        url.split(".")[url.split(".").length - 1].indexOf("zip") > -1 ||
        url.split(".")[url.split(".").length - 1].indexOf("rar") > -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    zipPreview(url) {
      window.open(url);
    },
    pdfPreview(url) {
      window.open(url);
    },
    handlePictureCardPreview(file) {
      this.previewPicDialog = true;
      this.dialogImageUrl = file.url;
    },
    uploadClose() {
      this.uploadDialog = false;
      this.fileList = [];
      this.isUploadVisible = false;
    },
    fileBindTask() {
      this.fileList = [];
      this.yszVisable = false
    },
    yszVisableClose() {
      this.fileList = []
      this.yszVisable = false
    },
    // 验收单关闭
    handleClose(val) {
      this.yszVisable = val;
    },
    // 查看验收单
    handleYsd(row) {
      if (!row.finishProofPath2) {
        this.$message({
          showClose: true,
          type: "warning",
          message: "当前服务成果验收单不存在！",
        });
        return;
      }
      const list = row.finishProofPath2.split(",");
      list.filter((item) => {
        this.fileList.push({ url: item });
      });
      // const type = row.finishProofPath2.split('.')[4]
      // 判断文件类型
      // if (type === 'doc' || type === 'docx' || type === 'xlsx' || type === 'xls' || type === 'ppt' || type ===
      //                 'pptx' || type === 'pdf') {
      //     // 在当前浏览器直接下载
      //     window.open(row.finishProofPath2)
      // } else {
      //     // 图片在浏览器打开 新的页面展示
      //     this.yszVisable = true;
      //     this.yszImg = row.finishProofPath2
      // }
      this.yszVisable = true;
    },
    calcTableHeight() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const el = this.$el;
          if (!el) return;
          const searchArea = el.querySelector('.search-form-area');
          const pagination = el.querySelector('.el-pagination');
          const searchH = searchArea ? searchArea.offsetHeight : 0;
          const paginationH = pagination ? pagination.offsetHeight : 0;
          const h = el.clientHeight - searchH - paginationH - 4;
          if (h > 100) this.tableHeight = h;
        });
      });
    },
    // 统计金额
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 9) {
          //指定哪一列合计 如果需要全部合计 去掉这个判断即可
          sums[9] =
            this.countNum && this.countNum.money
              ? Number(this.countNum.money).toFixed(2)
              : "0.00";
        } else if (index === 10) {
          //指定哪一列合计 如果需要全部合计 去掉这个判断即可
          sums[10] =
            this.countNum && this.countNum.amountPayable
              ? Number(this.countNum.amountPayable).toFixed(2)
              : "0.00";
        } else if (index === 11) {
          //指定哪一列合计 如果需要全部合计 去掉这个判断即可
          sums[11] =
            this.countNum && this.countNum.serviceCharge
              ? Number(this.countNum.serviceCharge).toFixed(2)
              : "0.00";
        }
      });
      return sums;
    },
    //            任务大类请求
    getDropDownData() {
      this.$http
        .get(
          "sys/plat/ticketPro/page?page=1&limit=1000"
        )
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.taskList = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    async handleQuery(isPage) {
      this.pageObject.page = isPage ? this.pageObject.page : 1;
      const countRes = await this.$http.get(`/sys/plat/deal/approval/count`, {
        params: {
          ...this.form,
          taskType: this.form.taskType
            ? ArrayUtils.getItemBy(
              this.taskList,
              "ticketProject",
              this.form.taskType
            ).ticketProject
            : "",
        },
      });
      this.countNum = countRes.data.data;
      const res = await this.$http.get(
        `/sys/plat/deal/approval/isBatchSubmitPage?page=${this.pageObject.page
        }&limit=${this.pageObject.limit}&taskType=${this.form.taskType
          ? ArrayUtils.getItemBy(
            this.taskList,
              "ticketProject",
            this.form.taskType
          ).ticketProject
          : ""
        }&money1=${this.form.money1}&money2=${this.form.money2}&dealCode=${this.form.dealCode
        }&dealBody=${this.form.dealBody}&status=${this.form.status
        }&startDate=${this.form.startDate ? this.form.startDate : ""
        }&endDate=${this.form.endDate ? this.form.endDate : ""}&bodyId=${this.form.bodyId ? this.form.bodyId : ""}`
      );
      if (res.data.code == 0) {
        this.dataList = res.data.data.list;
        this.pageObject.total = res.data.data.total;
        this.calcTableHeight();
      }
      this.$nextTick(() => {
        if (this.$refs.refTable) {
          this.$refs.refTable.doLayout();
        }
      });
    },
    //收款方信息查看
    handleSee(row) {
      localStorage.setItem(`4${this.$route.name}`, JSON.stringify(this.form));
      const routeParams = {
        routeName: `${this.$route.name}__收款方信息`,
        title: `收款方信息`,
        path: "plat/batch-settlement-list/content/payee-info",
        params: {
          id: row.id,
        },
      };
      // 动态路由
      addDynamicRoute(routeParams, this.$router);
    },
    //任务发布编号
    goTaskInfo(id) {
      localStorage.setItem(`4${this.$route.name}`, JSON.stringify(this.form));
      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__任务详情`,
        title: `任务详情`,
        path: "plat/platttask-info",
        params: {
          id: id,
        },
      };
      // 动态路由
      addDynamicRoute(routeParams, this.$router);
    },
    // 合同编号
    infoHandle(row) {
      localStorage.setItem(`4${this.$route.name}`, JSON.stringify(this.form));
      // 路由参数
      // const routeParams = {
      //   routeName: `${this.$route.name}__合同详情`,
      //   title: `合同详情`,
      //   path: "plat/platcontract-info",
      //   params: {
      //     id: row.contractId,
      //   },
      // };
      // 动态路由
      // addDynamicRoute(routeParams, this.$router);
      // if(row.bodyId == '1453241566079012865'){
      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__合同详情`,
        title: `合同详情`,
        path: 'plat/platcontract-info',
        params: {
          id: row.contractId
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)

      //     }else{
      //     // 路由参数
      //     const routeParams = {
      //         routeName: `${this.$route.name}__合同信息`,
      //         title: `合同信息`,
      //         path: 'user/contractDetail',
      //         params: {
      //             isContractList:true,
      //             id: row.userId,
      //         }
      //     }
      //     // 动态路由
      //     addDynamicRoute(routeParams, this.$router)
      // }
    },
    // 进入审核弹框
    openAuditDia(item) {
      this.auditInfo = {
        id: item.id,
        realName: item.publishName,
        money: item.money,
      };
      this.dialogToExamineVisible = true;
    },
    // 审核提交
    handleAudit(val) {
      this.$http
        .post("/sys/plat/deal/approval/batchAudit", {
          id: val.id,
          result: val.state,
          reason: val.reason,
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
            this.handleQuery();
            this.$parent.$parent.getNum();
          } else {
            this.$message.success("操作成功");
            this.handleQuery();
            this.$parent.$parent.getNum();
          }
        });
    },
    //            关闭提示框
    handleCloseA(val) {
      this.dialogToExamineVisible = val;
    },
    //分页
    handlePageSize(val) {
      this.pageObject.page = 1;
      this.pageObject.limit = val;
      this.handleQuery();
    },
    //当前页数
    handleCurrentPage(val) {
      this.pageObject.page = val;
      this.handleQuery(true);
    },
    //选中的表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //支付 进入支付明细弹框
    handlePayment(val) {
      this.paymentInfo = [];
      this.paymentInfo.push({ id: val.id });
      this.dialogToBePaidVisible = true;
    },

    //进入支付弹框
    paymentSubmit(payData) {
      this.$refs.dialogpay.init();
      // this.$refs.dialogpay.paymentInfo = this.paymentInfo;
      this.dialogToBePaidVisible = payData.flag;
      this.$refs.dialogpay.form.payTotal = payData.total;
      this.$refs.dialogpay.idTotal = payData.IdSum;
      this.$refs.dialogpay.form.code = "";
      this.$refs.dialogpay.form.paypass = "";
    },
    //            支付成功刷新页面,关闭所有弹框
    paySuccess() {
      this.handleClose(false);
      this.handleQuery();
      this.$parent.$parent.getNum();
    },
    //            关闭弹框
    handleClose(flag) {
      this.dialogToBePaidVisible = flag;
    },
    //            回退到支付明细弹框
    CancelPay() {
      this.$refs.dialogpay.dialogClose();
      this.dialogToBePaidVisible = true;
    },
    //进入设置密码弹框
    modifyPayPassword() {
      this.$nextTick(() => {
        this.$refs.SetPwd.init();
        this.$refs.SetPwd.type = 1;
      });
    },
    //重置
    handleReset() {
      this.form.taskType = "";
      this.form.money1 = "";
      this.form.money2 = "";
      this.form.bodyId = "";
      this.form.dealCode = "";
      this.form.dealBody = "";
      this.form.startDate = "";
      this.form.endDate = "";
      this.form.status = "";
      this.handleQuery();
    },
    // 获取税源地列表
    async getBodyPageList() {
      const res = await this.$http.get('/sys/plat/body/page?page=1&limit=1000', {});
      if (res.data.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.bodyPageList = res.data.data.list
      }
    },
  },
  created() {
    console.log('初始化')
    this.getDropDownData();
    this.getBodyPageList();
    if (localStorage.getItem(`4${this.$route.name}`)) {
      this.form = JSON.parse(localStorage.getItem(`4${this.$route.name}`));
    }
    this.handleQuery();
  },
  mounted() {
    this.$nextTick(() => { this.calcTableHeight(); });
    window.addEventListener('resize', this.calcTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight);
  },
};
</script>
<style lang="scss">
.settlement-tab-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;

    .search-form-area {
        flex-shrink: 0;
    }

    > .el-table {
        flex: 1;
    }

    > .el-pagination {
        flex-shrink: 0;
        padding: 10px 0;
        text-align: right;
    }
}
.selection .cell{
    padding: 0 !important;
}
</style>